<style lang="less">
    .loading{
        text-align: center;
        img{
            animation: rotate 0.8s infinite linear;
            -webkit-animation: rotate 0.8s infinite linear;
        }
        @keyframes rotate {
          0% { -webkit-transform: rotate(0deg) }
          100% { -webkit-transform: rotate(360deg) }
        }
        @-webkit-keyframes rotate {
          0% { -webkit-transform: rotate(0deg) }
          100% { -webkit-transform: rotate(360deg) }
        }
        
    }
</style>

<template>
  <div class="loading">
    <img :src="src" :style="'width:'+width">
  </div>

</template>

<script>
  import loadingIcon from '../image/iconLoading.png'
  export default {
    props: ['isShow','size'],
    data(){
      return {
        src: loadingIcon,
        width: this.size
      }
    },
    created: function(){
     
    },
    computed: {
     
    },
    watch: {
      
    },
    mounted() {
    },
    methods: {
      
    }
  }

</script>
